/**
 * D1: App Preferences (group, period)
 * Source: src/app/store.ts lines 375-428
 */

import { USE_BACKEND, STORAGE_KEY } from '../helpers';
export async function getGroup(): Promise<string | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY}_group`);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
}
export async function setGroup(group: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    localStorage.setItem(`${STORAGE_KEY}_group`, JSON.stringify(group));
  } catch {

    /* quota */}
}
export async function getPeriod(): Promise<string | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY}_period`);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
}
export async function setPeriod(period: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    localStorage.setItem(`${STORAGE_KEY}_period`, JSON.stringify(period));
  } catch {

    /* quota */}
}
export async function clearPeriod(): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    localStorage.removeItem(`${STORAGE_KEY}_period`);
  } catch {

    // silent
  }
}